import React from 'react';

const Configuration = ({ config }) => {
  if (!config) return null;

  const fields = [
    'assetName', 'assetDescription', 'dataAssetOwner', 'region', 'market',
    'technicalDataSteward', 'refreshFrequency', 'completeness', 'accuracy',
    'consistency', 'sampleSize', 'dataframeName'
  ];

  const formatLabel = (label) => {
    if (!label) return 'N/A';
    return label
      .replace(/_/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase());
  };

  return (
    <div className="overflow-x-auto mb-6">
      <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
        <thead className="bg-[#0000a0]">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Label</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Value</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {fields.map((key) => (
            <tr key={key} className="hover:bg-gray-50 transition-colors">
              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{formatLabel(key)}</td>
              <td className="px-6 py-4 text-sm text-gray-700">{config?.[key] || 'N/A'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Configuration; 